import type { Character } from './types';

let cache: Character[] | null = null;

export async function loadCharacters(): Promise<Character[]> {
  if (cache) return cache;
  const r = await fetch('/api/characters');
  if (!r.ok) throw new Error(`characters api: ${r.status}`);
  cache = (await r.json()) as Character[];
  return cache;
}

export function spriteUrl(c: Character): string {
  return `/api/asset/${c.sprite_key}`;
}

export async function saveBattle(left: string[], right: string[], winner: string, duration_ms: number) {
  try {
    await fetch('/api/battles', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ left, right, winner, duration_ms }),
    });
  } catch {}
}
